import React from 'react';
import useLogger from 'hooks/useLogger';
import { NavBarData, NikeConnected, StoreIdentifierName } from '../../../../types';
import { checkStores, setDataEmTag } from '../../../../utility/utility';
import setIcon from '../icon-selector';
import './MobileNavBar.scss';

type Props = {
  navBarData: NavBarData[] | undefined;
  storeIdentifierName: StoreIdentifierName;
  nikeConnected: NikeConnected;
};

export default function MobileNavBar({
  navBarData = [],
  storeIdentifierName,
  nikeConnected,
}: Props) {
  const { error } = useLogger();

  try {
    return (
      <div className="MobileNavBar-container">
        {nikeConnected && nikeConnected.value === 'true' && (
          <div className="MobileNavBar-container__text-container">
            {setIcon(
              '',
              storeIdentifierName,
              'MobileNavBar-container__text-container--icon hmf-px-xs',
            )}
            <a
              tabIndex={0}
              href="/f/all-nike-connected-membership"
              title="DICK'S | Nike"
              data-em={setDataEmTag('Header', 'header_dicks_nike')}
              className="MobileNavBar-container__text-container--links hmf-py-s">
              <p className="MobileNavBar-container__text-container--link-title">
                DICK&#39;S | Nike
              </p>
            </a>
          </div>
        )}
        {navBarData?.map((links: NavBarData) => {
          // In order to be able to catch the error with ErrorBoundaryWithLogger and to avoid the component from breaking
          // We need to catch the error in try-catch and still wrap with ErrorBoundaryWithLogger
          try {
            return (
              <div
                key={`link-${links.linkTitle}`}
                className="MobileNavBar-container__text-container hmf-p-s hmf-px-md-m">
                {setIcon(
                  links.mobileIcon ?? '',
                  storeIdentifierName,
                  'MobileNavBar-container__text-container--icon',
                )}
                <a
                  tabIndex={0}
                  href={checkStores(links.link)}
                  title={links.linkTitle}
                  data-em={setDataEmTag('Header', links.linkTitle)}
                  className="MobileNavBar-container__text-container--links hmf-body-bold-m hmf-pl-xxs">
                  <p className="MobileNavBar-container__text-container--link-title">
                    {links.linkTitle}
                  </p>
                  {links.description && (
                    <p className="MobileNavBar-container__text-container--description hmf-body-s">
                      {links.description}
                    </p>
                  )}
                </a>
              </div>
            );
          } catch (e) {
            return null;
          }
        })}
      </div>
    );
  } catch (e) {
    error('Could not load MobileNavBar - ', e);
    return null;
  }
}
